import { ApplicationDocument } from "../../policyAdmin/types/PolicyAdmin.types";

export interface QuickRefer {
  pas: string;
  pas_application_id: string;
  status?: string;
  accelerant_referral_id?: string;
  accelerant_status?: string;
  data?: QuickReferralForm;
  history?: ApplicationHistory[];
}

export interface QuickReferPayload {
  pas: string;
  pas_application_id: string;
  status: string;
  accelerant_referral_id?: string | null;
  accelerant_status?: string | null;
  data?: QuickReferralForm;
  history?: ApplicationHistory[];
}

// API History tracking types
export enum ApiCallType {
  GET_APPLICATION_BY_ID = "get_application_by_id",
  GET_DOCUMENTS = "get_documents",
  CREATE_DRAFT = "create_draft",
  UPLOAD_ATTACHMENTS = "upload_attachments",
  UPDATE_STATUS_SUBMITTED = "update_status_submitted",
  GET_REFERRAL_BY_ID = "get_referral_by_id",
  CHECK_SUBMISSION = "check_submission",
}

export interface ApiHistoryEntry {
  timestamp: string;
  type: ApiCallType;
  success: boolean;
  error?: string;
  url?: string;
  response?: any;
}

export interface ApplicationHistory {
  submittedAt: string;
  entries: ApiHistoryEntry[];
  status: "success" | "failed";
  failedAt?: ApiCallType;
  lastSuccessfulStep?: ApiCallType;
}

export interface QuickReferralForm {
  // Application fields
  type?: string;
  named_insured?: string;
  number?: string;
  program?: string;
  underwriter?: string;
  effective_date?: string;
  expiration_date?: string;
  total_locations_limit?: number;

  // Additional fields for referral
  summaryOfRisk: string;
  referralReasons: string[];
  documents: ApplicationDocument[];
}
